import { EMPTY_STRING } from '../../../constants/common'

function getApplicantIdentityValue(applicant) {
  return applicant?.identity?.value ?? EMPTY_STRING
}

export function getIsRentalPortalApplicantIdentityMasked(applicant) {
  return (
    applicant?.identity?.masked !== false ||
    !getApplicantIdentityValue(applicant)
  )
}

export function getRentalPortalApplicantIdentityName(applicant) {
  return getIsRentalPortalApplicantIdentityMasked(applicant)
    ? EMPTY_STRING
    : getApplicantIdentityValue(applicant)
}

export function getRentalPortalApplicantIdentityLabel({ applicant, t }) {
  return (
    getRentalPortalApplicantIdentityName(applicant) ||
    (applicant?.reference
      ? t('RentalPortal.ApplicantIdentityReferenceKey', {
          ref: applicant.reference,
        })
      : t('RentalPortal.ApplicantProfileMaskedValueKey'))
  )
}

export function getIsRentalPortalApplicantNew(applicant) {
  return Boolean(applicant?.unseen)
}
